<template>
    <div class="journey-addons-addon">
        <Icon v-if="icon" :type="icon" />
        <div>
            {{ description }}
        </div>
    </div>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, PropType } from 'vue';
    import { Type as IconType } from '@ui/components/Icon/Icon.interfaces';
    import Icon from '@ui/components/Icon/Icon.vue';

    export default defineComponent({
        name: 'JourneyFerryAddonNew',
        methods: { t },
        components: { Icon },
        props: {
            description: {
                type: String,
                required: true,
            },
            detailed: { type: Boolean, default: false },
            icon: { type: String as PropType<IconType> },
        },
    });
</script>
<style lang="scss" scoped>
    @forward 'Addon';
</style>
